// The Dray Dog extension adds a notification holder div to all tabs it's active on, and
// currently we are using that to detect if the extension is installed or not
const DRAYDOG_EXTENSION_NOTIFICATION_HOLDER_ID = 'draydog-notification-app'

export function isDrayDogExtensionInstalled(): boolean {
  return (
    document.getElementById(DRAYDOG_EXTENSION_NOTIFICATION_HOLDER_ID) !== null
  )
}

export function waitForExtensionDetection(
  timeoutMs: number = 3000
): Promise<boolean> {
  return new Promise((resolve) => {
    // Check immediately first
    if (isDrayDogExtensionInstalled()) {
      resolve(true)
      return
    }

    const observer = new MutationObserver(() => {
      if (isDrayDogExtensionInstalled()) {
        observer.disconnect()
        resolve(true)
      }
    })

    // Only observe direct children of body, not the entire subtree
    observer.observe(document.body, {
      childList: true,
      // The notifications container will always be appended to the body, so we don't
      // need to observe the entire DOM
      subtree: false,
    })

    setTimeout(() => {
      observer.disconnect()
      resolve(false)
    }, timeoutMs)
  })
}
